import { Commodity } from "./Commodity";
import { CountryData } from "./Location";
import { Pagination } from "./Pagination";

export class BulkBookingEntities {
  pagination: Pagination;
  data: BulkBookingData[];

  constructor(pagination: Pagination, data: BulkBookingData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class BulkBookingData {
  uploadId: string;
  activityName: string;
  documentType: string;
  createdFor: string;
  createdForCode: string;
  createdAt: Date;
  createdBy: string;
  totalStt: number;
  totalSttSuccess: number;
  status: string;
  archiveFile: string;
  failedFile: string;
  createdType: string;
  dataProcessedCurrent: number;
  totalDataCurrent: number;
  totalSttRepaired: number;
  createdId: number;
  fileName: string;
  bookingType: string;
  constructor(
    uploadId: string,
    activityName: string,
    documentType: string,
    createdFor: string,
    createdForCode: string,
    createdAt: Date,
    createdBy: string,
    totalStt: number,
    totalSttSuccess: number,
    status: string,
    archiveFile: string,
    failedFile: string,
    createdType: string,
    dataProcessedCurrent: number,
    totalDataCurrent: number,
    totalSttRepaired: number,
    createdId: number,
    fileName: string,
    bookingType: string
  ) {
    this.uploadId = uploadId;
    this.activityName = activityName;
    this.documentType = documentType;
    this.createdFor = createdFor;
    this.createdForCode = createdForCode;
    this.createdAt = createdAt;
    this.createdBy = createdBy;
    this.totalStt = totalStt;
    this.status = status;
    this.totalSttSuccess = totalSttSuccess;
    this.archiveFile = archiveFile;
    this.failedFile = failedFile;
    this.createdType = createdType;
    this.dataProcessedCurrent = dataProcessedCurrent;
    this.totalDataCurrent = totalDataCurrent;
    this.totalSttRepaired = totalSttRepaired;
    this.createdId = createdId;
    this.fileName = fileName;
    this.bookingType = bookingType;
  }
}

export class BulkBookingSuccess {
  bulkId: number;
  sttSuccess: BookedSttSuccess[];
  constructor(bulkId: number, sttSuccess: BookedSttSuccess[]) {
    this.bulkId = bulkId;
    this.sttSuccess = sttSuccess;
  }
}

export class BookedSttSuccess {
  manualSttNumber: string;
  originDistrictCode: string;
  destinationDistrictCode: string;
  shipperName: string;
  shipperAddress: string;
  shipperPhone: string;
  consigneeName: string;
  consigneeAddress: string;
  consigneePhone: string;
  totalPieces: string;
  totalWeight: string;
  commodityCode: string;
  productType: string;
  insuranceServiceType: string;
  valueOfGoods: number;
  externalNumber: string;
  cod: string;
  woodpacking: string;
  ppn: number;
  pph: number;
  shippingRate: number;
  insuranceRate: number;
  totalSurcharge: number;
  totalAmount: number;
  incomingRate: number;
  constructor(
    manualSttNumber: string,
    originDistrictCode: string,
    destinationDistrictCode: string,
    shipperName: string,
    shipperAddress: string,
    shipperPhone: string,
    consigneeName: string,
    consigneeAddress: string,
    consigneePhone: string,
    totalPieces: string,
    totalWeight: string,
    commodityCode: string,
    productType: string,
    insuranceServiceType: string,
    valueOfGoods: number,
    externalNumber: string,
    cod: string,
    woodpacking: string,
    ppn: number,
    pph: number,
    shippingRate: number,
    insuranceRate: number,
    totalSurcharge: number,
    totalAmount: number,
    incomingRate: number
  ) {
    this.manualSttNumber = manualSttNumber;
    this.originDistrictCode = originDistrictCode;
    this.destinationDistrictCode = destinationDistrictCode;
    this.shipperName = shipperName;
    this.shipperAddress = shipperAddress;
    this.shipperPhone = shipperPhone;
    this.consigneeName = consigneeName;
    this.consigneeAddress = consigneeAddress;
    this.consigneePhone = consigneePhone;
    this.totalPieces = totalPieces;
    this.totalWeight = totalWeight;
    this.commodityCode = commodityCode;
    this.productType = productType;
    this.insuranceServiceType = insuranceServiceType;
    this.valueOfGoods = valueOfGoods;
    this.externalNumber = externalNumber;
    this.cod = cod;
    this.woodpacking = woodpacking;
    this.ppn = ppn;
    this.pph = pph;
    this.shippingRate = shippingRate;
    this.insuranceRate = insuranceRate;
    this.totalSurcharge = totalSurcharge;
    this.totalAmount = totalAmount;
    this.incomingRate = incomingRate;
  }
}

export class BulkBookingResiEntities {
  data: BulkBookingResiData[];
  constructor(data: BulkBookingResiData[]) {
    this.data = data;
  }
}

export class BulkBookingResiData {
  sttNo: string;
  sttId: number;
  constructor(sttNo: string, sttId: number) {
    this.sttNo = sttNo;
    this.sttId = sttId;
  }
}

export class BulkBookingAddForm {
  type = "Bulk Booking";
  activityName = "";
  archiveFile = "";
  clientName = "";
  formatTemplate = "";
  constructor(fields?: Partial<BulkBookingAddForm>) {
    Object.assign(this, fields);
  }
}

export class ClientBookingEntities {
  pagination: Pagination;
  data: ClientBookingListData[];
  constructor(pagination: Pagination, data: ClientBookingListData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class ClientBookingListData {
  id = 0;
  accountName = "";
  accountId = 0;
  createdBy = "";
  createdAt = new Date();
  updatedBy = "";
  updatedAt = new Date();
  constructor(fields?: Partial<ClientBookingListData>) {
    Object.assign(this, fields);
  }
}

export class HeaderMapping {
  genesisHeader = "";
  sourceHeader = "";
  activitySelect = false;
  constructor(fields?: Partial<HeaderMapping>) {
    Object.assign(this, fields);
  }
}

export class ClientBookingTemplateDetail {
  id = 0;
  accountRefId = 0;
  accountRefType = "";
  accountRefName = "";
  accountRefCode = "";
  createdAt = new Date();
  createdBy = "";
  updatedAt = new Date();
  updatedBy = "";
  headerMapping = [] as HeaderMapping[];

  constructor(fields?: Partial<ClientBookingTemplateDetail>) {
    Object.assign(this, fields);
  }
}

export class DownloadTemplateData {
  title = "";
  isButton = true;
  url = "";
  permission = true;
  id = "";
  type = "";

  constructor(fields?: Partial<DownloadTemplateData>) {
    Object.assign(this, fields);
  }
}

export class CommodityData {
  id = 0;
  name = "";
  nameId = "";
  nameEn = "";
  code = "";
  status = "";
  isDangerousGoods = false;
  isQuarantine = false;
  hsCode = "";
  constructor(fields?: Partial<CommodityData>) {
    Object.assign(this, fields);
  }
}

export class DestinationCity {
  cityId = 0;
  id = 0;
  name = "";
  status = "";
  code = "";
  cityCode = "";
  vendorCode = "";
  type = "";
  isCod = "";
  countryCode = "";
  countryName = "";
  postalCode = "";
  vendor_code = "";
  constructor(fields?: Partial<DestinationCity>) {
    Object.assign(this, fields);
  }
}

export class PostalCodeDestination {
  id = 0;
  name = "";
  constructor(fields?: Partial<PostalCodeDestination>) {
    Object.assign(this, fields);
  }
}

export class OriginCity {
  id = 0;
  name = "";
  code = "";
  cityCode = "";
  status = "";
  type = "f";
  cityId = 0;
  vendorCode = "";
  isCod = "";
  isFtz = "";
  constructor(fields?: Partial<OriginCity>) {
    Object.assign(this, fields);
  }
}

export class ClientData {
  id = 0;
  name = "";
  originalClientName = "";
  status = false;
  isDO = false;
  isCOD = false;
  clientCode = "";
  clientOriginCity = "";
  clientCategory = "";
  clientPackageType = "";
  clientCodConfigurationData = "";
  clientCodConfigAmountData = "";
  clientAlias = "";
  clientName = "";
  clientId = 0;
  clientCountry = "";
  isFtz = false;
  constructor(fields?: Partial<ClientData>) {
    Object.assign(this, fields);
  }
}

export class BookingData {
  shipmentId = 0;
  externalNumber = "";
  manualSttNumber = "";
  destinationDistrictName = "";
  destinationPostalCode = "";
  shipperName = "";
  shipperAddress = "";
  shipperPhoneNumber = "";
  consigneeName = "";
  consigneeAddress = "";
  consigneesAddressType = "";
  consigneePhone = "";
  totalPieces = 0;
  totalWeight = 0;
  commodityCode = "";
  productType = "";
  valueOfGoods = 0;
  insuranceFlag = false;
  serviceType = "";
  codAmount = "";
  originDistrictName = "";
  commodity = new CommodityData();
  destinationCity = new DestinationCity();
  postalCodeDestination = new PostalCodeDestination();
  originCity = new OriginCity();
  originCountry = new CountryData();
  clientData = new ClientData();
  sttRecipientEmail = "";
  sttIdentityNumber = "";
  sttInterTaxNumber = "";
  isInternational = false;
  sttCipl: any[] = [];
  sttDutyTaxTerms = "";

  constructor(fields?: Partial<BookingData>) {
    Object.assign(this, fields);
  }
}

export class ErrorBookingData {
  shipmentId = null;
  externalNumber = null;
  manualSttNumber = null;
  destinationDistrictName = null;
  destinationPostalCode = null;
  shipperName = null;
  shipperAddress = null;
  shipperPhoneNumber = null;
  consigneeName = null;
  consigneeAddress = null;
  consigneesAddressType = null;
  consigneePhone = null;
  totalPieces = null;
  totalWeight = null;
  commodityCode = null;
  productType = null;
  valueOfGoods = null;
  insuranceFlag = null;
  serviceType = null;
  codAmount = null;
  originDistrictName = null;
  sttRecipientEmail = null;
  sttIdentityNumber = null;
  sttInterTaxNumber = null;
  sttCipl = null;
  dutyTaxTerms = null;
  note = null;
  woodPacking: any = null;
  ciplItems: any[] = [];

  constructor(fields?: Partial<ErrorBookingData>) {
    Object.assign(this, fields);
  }
}

export class DetailRepairBulkBooking {
  rowNumber = 0;
  status = "";
  totalRepaired = 0;
  totalFailed = 0;
  repairPosition = "";
  bookedType = "";
  clientId = 0;
  partnerId = 0;
  bookingData = new BookingData();
  errorBookingData = new ErrorBookingData();

  constructor(fields?: Partial<DetailRepairBulkBooking>) {
    Object.assign(this, fields);
  }
}
